import * as React from 'react';
import MainPageCore from './main-page-core';
export const MainContext = React.createContext({
    hasMainPageComponent: false,
});
const MainPage = (props) => {
    const { children, className } = props;
    return React.createElement(MainPageCore, { className: className }, children);
};
export default MainPage;
